/** @format */

import { Component, Input, OnInit, input } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSearch,
	homefieldIconStarFilled0Percent,
	homefieldIconStarFilled100Percent,
	homefieldIconStarFilled25Percent,
	homefieldIconStarFilled50Percent,
	homefieldIconStarFilled75Percent
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'homefield-star-ratings',
	imports: [HomefieldIconLibraryModule],
	templateUrl: './star-ratings.component.html'
})
export class HomefieldStarRatingsComponent implements OnInit {
	@Input() ratingCount: number | string = 0;
	@Input() ratingValue = 0;
	showCustomerRating = input(false);

	stars = [];

	constructor(private homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconStarFilled0Percent,
			homefieldIconStarFilled100Percent,
			homefieldIconStarFilled25Percent,
			homefieldIconStarFilled50Percent,
			homefieldIconStarFilled75Percent,
			homefieldIconSearch
		]);
	}

	ngOnInit(): void {
		if (!this.ratingCount) {
			return;
		}
		this.setStars();
	}

	/**
 * @description The rating logic
 * Which star icon to show for the decimal value of rating.
    0.0 - 0.24 = unfilled
    0.25 - 0.49 = quarter filled star
    0.5 - 0.74 = half filled star
    0.75 - 0.99 = three quarters filled star
 */
	setStars(): void {
		const starIcons = [
			'star-filled-0-percent',
			'star-filled-25-percent',
			'star-filled-50-percent',
			'star-filled-75-percent',
			'star-filled-100-percent'
		];

		for (let i = 1; i <= 5; i++) {
			if (this.ratingValue >= i) {
				this.stars.push(starIcons[4]);
			} else if (Math.trunc(this.ratingValue) + 1 < i) {
				this.stars.push(starIcons[0]);
			} else {
				//Calculates the index in which range the decimal value lands. Eg. rating value = 4.35 then index will be 1
				const index = Math.floor((this.ratingValue % 1) / 0.25);
				this.stars.push(starIcons[index]);
			}
		}
	}

	trackByFn(index: number, item: any): string {
		return index.toString() + item;
	}
}
